<script>
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';
import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util";
//import XLSX from "xlsx";
//import downloadFiles from "@/services/download-files";

var formInputs = {
    searchParams: [
        {
            "key": "querySQLContains",
            "label": "Query SQL Contains:",
            "attrs": {
                "type": "textarea"
            },
            'helperText': [
                `Newline delimited list of search terms.  Will combine with 'AND'.`
            ]
        },
        {
            "key": "queryTargetContains",
            "label": "Query Target DE Name Contains:",
            "attrs": {
                "type": "text"
            }
        }
    ]
};
var formDefaultValues = {
    querySQLContains: "",
    queryTargetContains: ""
};

export default {
    name: 'QuerySearchToolView',
    components: {
        FormInputGroupView
    },
    data: function() {
        var data = {
            uiState: 'ready',
            form: {
                inputs: FormInputGroup.makeInputs(formInputs),
                values: FormInputGroup.makeValues(formInputs, formDefaultValues),
                valuesSubmitted: FormInputGroup.makeValues(formInputs, formDefaultValues)
            },
            results: []
        };
        return data;
    },
    methods: {
        isUIState: function(target) {
            return this.uiState.match(new RegExp(`^${target}`));
        },
        formChange: function(event) {
            this.form.values[event.key] = event.value;
        },
        submit: function() {
            var formValues = JSON.parse(JSON.stringify(this.form.values));
            if (!this.isUIState('ready')) {
                return Promise.resolve();
            }
            if (
                !formValues.queryTargetContains.replace(/^\s+/, '').replace(/\s+$/, '').length &&
                !formValues.querySQLContains.replace(/^\s+/, '').replace(/\s+$/, '').length
            ) {
                alert("Please enter search criteria.")
                return Promise.resolve();
            }
            this.uiState = 'retrieving';
            this.results = [];
            this.form.valuesSubmitted = formValues;

            //
            // Form the request
            var filter = null;
            var pushToFilter = (simpleFilter, logicalOperator) => {
                if (filter === null) {
                    filter = simpleFilter;
                } else {
                    filter = this.sfmcQuery.complexFilter(
                        simpleFilter,
                        logicalOperator,
                        filter
                    );
                }
            };
            if (formValues.querySQLContains) {
                formValues.querySQLContains.replace(/^\s+/, '').replace(/\s+$/, '').split("\n").forEach((containsStr) => {
                    var queryTextFragment = containsStr.replace(/^\s+/, '').replace(/\s+$/, '');
                    if (queryTextFragment.length) {
                        pushToFilter(
                            this.sfmcQuery.simpleFilter(
                                'QueryText',
                                containsStr.replace(/^\s+/, '').replace(/\s+$/, ''),
                                'like',
                                'Value'
                            ),
                            'AND'
                        );
                    }
                })
            }
            if (formValues.queryTargetContains) {
                pushToFilter(
                    this.sfmcQuery.simpleFilter(
                        'DataExtensionTarget.Name',
                        formValues.queryTargetContains,
                        'like',
                        'Value'
                    ),
                    'AND'
                );
            }
            
            pushToFilter(
                this.sfmcQuery.simpleFilter(
                    'Status',
                    'Active',
                    'equals',
                    'Value'
                ),
                'AND'
            );

            return this.sfmcQuery.apiCall(
                'retrieve',
                {
                    complex_filter: filter,
                    get_properties: ["Name","QueryText","DataExtensionTarget.Name","ModifiedDate","CreatedDate","TargetUpdateType","Status"]
                }
            ).then(
                (response) => {
                    this.results = response.data;
                    this.uiState = 'ready-submitted';
                }
            );

        },
        objectPluralify: function(objectLabel, object) {
            return `${objectLabel}${(object.length != 1) ? 's' : ''}`;
        }
    },
    created: function() {
        this.sfmcQuery = flywhweelSFMCUtilFactory(this, 'query');
        this.formInputs = FormInputGroup.util(() => this.form.inputs);
    },
    watch: {
        uiState: function() {
            if (this.isUIState('retrieving')) {
                this.formInputs.forEach((input) => {
                    input.attrs.disabled = true;
                });
            } else if (this.isUIState('ready')) {
                this.formInputs.forEach((input) => {
                    input.attrs.disabled = false;
                });
            }
        }
    }
}
</script>
<template src="./QuerySearchTool.html"></template>
<style lang="scss" src="./QuerySearchTool.scss"></style>